import ButtonT from '@components/tailwind-components/Button/ButtonT';
import InputWithLabelT from '@components/tailwind-components/Input/InputWithLabelT';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { useModal } from '../../../../hooks/modal/useModal';
import { useMfaDisableForm } from '../../../../hooks/settings/account/useMFADisableForm';

export const Disable2FaModal: React.FC = () => {
  const { handleSubmit, control } = useMfaDisableForm();

  const { hideModal } = useModal();
  const { t } = useTranslation();

  return (
    <form className='tailwind-modal-form' onSubmit={handleSubmit}>
      <div className='tailwind-modal-body'>
        <p className='text-sm mb-2 italic'>
          {t('account-settings.2fa.modals.disable.confirmation')}
        </p>
        <div className='grid grid-cols-1 gap-x-6 gap-y-2'>
          <div className='col-span-1'>
            <InputWithLabelT
              type='password'
              field='password'
              placeholder={t('account-settings.2fa.modals.disable.password')}
              label={t('account-settings.2fa.modals.disable.password')}
              id='password'
              control={control}
              options={{
                required: t('general.validation.required'),
              }}
            />
            <InputWithLabelT
              type='text'
              field='token'
              placeholder={t('account-settings.2fa.modals.enable.token')}
              label={t('account-settings.2fa.modals.enable.token')}
              id='token'
              control={control}
              options={{
                required: t('general.validation.required'),
                minLength: 6,
                maxLength: 6,
              }}
            />
          </div>
        </div>
      </div>
      <div className='tailwind-modal-footer'>
        <ButtonT
          type='button'
          styling='cancel'
          size='xs'
          rounding='md'
          onClick={() => {
            hideModal();
          }}>
          {t('general.buttons.cancel')}
        </ButtonT>
        <ButtonT type='submit' styling='primary' size='xs' rounding='md'>
          {t('account-settings.2fa.modals.disable.disable')}
        </ButtonT>
      </div>
    </form>
  );
};

export default Disable2FaModal;
